import {
    TENANTS_ROUTE
} from './constants';
import http from '../../utils/httpService';

/**
 *
 */
const requestTenantsList = () => {
    return http.request( TENANTS_ROUTE, 'GET' );
};

export {
    requestTenantsList
};
